import { TRIP_TYPE_CODES } from './tripTypes';

export const ASSIGNABLE_TRIP_TYPE_CODES = new Set([TRIP_TYPE_CODES.SCHEDULED]);
